const { default: Swiper, Navigation, Autoplay, Pagination } = require('swiper');
Swiper.use([Navigation, Autoplay, Pagination]);

const swiper = new Swiper('.mySwiper', {
  direction: 'horizontal',
  loop: true,
  speed: 400,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 5000,
  },
});
const swiper2 = new Swiper('.mySwiper2', {
  direction: 'horizontal',
  loop: true,
  speed: 400,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 5000,
  },
});

function setIconActive(i) {
  const icons = document.getElementsByClassName('succeed__item');
  if (i === 7) {
    icons[0].classList.add('active');
    for (let j = 1; j < icons.length; j++) {
      icons[j].classList.remove('active');
    }
    return;
  }
  if (i === 0) {
    icons[5].classList.add('active');
    for (let j = 0; j < icons.length - 1; j++) {
      icons[j].classList.remove('active');
    }
    return;
  }

  for (let j = 0; j < icons.length; j++) {
    if (j === i - 1) {
      icons[j].classList.add('active');
    } else {
      icons[j].classList.remove('active');
    }
  }
}

window.setSlideToActive = function setSlideToActive(i) {
  setIconActive(i);
  swiper.slideTo(i);
  swiper2.slideTo(i);
};

swiper.on('activeIndexChange', function (swiper) {
  setIconActive(swiper.activeIndex);
});

swiper2.on('activeIndexChange', function (swiper) {
  setIconActive(swiper.activeIndex);
});
